import React, { Component } from 'react';

import Analytics from 'APP_ROOT/services/analytics';
import HistoryUtil from '../../common/historyUtil';
import CognitoUtil from '../../aws/cognito/cognitoUtil';
import LambdaUtil from '../../aws/lambda/lambdaUtil';
import BuildSettings from '../../buildSettings';
import Events from '../../common/events';
import { strings } from '../../../localization';

export default class VerifyAccountPage extends Component {

    constructor(props) {

        super(props);

        this.state = {
            validateVerificationCodeMessage: null,
            errorMessage: null,
            resendStatus: null
        }
    }

    componentDidMount() {
        Analytics.pageView();
        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
    }

    onSubmit = (e) => {

        e.preventDefault();
        
        const username = this.getUserNameFromUrl();

        if (this.validateForm()) {
            document.dispatchEvent(new CustomEvent(Events.SHOW_LOADING_PAGE, { detail: { loadingPageMessage: strings.formatString(strings.verify_account_creating) } }));
            CognitoUtil.confirmRegistration(username, this.verificationCode.value, this.registerUserSuccess, this.registerUserFail);
        }
    }

    onResendCode = (e) => {
        e.preventDefault();
        const username = this.getUserNameFromUrl();

        this.setState({ resendStatus: 'sending' });

        CognitoUtil.resendConfirmationCode(username, 
            () => { // onSuccess
                this.setState({ resendStatus: 'sent' });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }, 
            (err) => { // onFail
                console.error(err);
                this.setState({ 
                    resendStatus: 'error',
                    errorMessage: strings.formatString(strings.verify_account_error_resending_code)
                });
            }
        );
    }

    registerUserFail = (e) => {
        console.log(e);
        
        if (e.message === "An account with the email already exists.") {

            // if pending invite, redirect to login page and continue invitation process from there
            // This could happen when user revisits an invitation link and goes through the verification process again
            if(this.props.pendingInvite){
                HistoryUtil.push('/');
                return;
            }

            
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

            // if not pending invite, then show error message
            this.setState({
                errorMessage: strings.formatString(strings.verify_account_error_already_exists)
            });
            return;
        }

        // This error means that the user has probably reloaded the page and the userInformation is lost
        // So, although the verification is successful, we can't authenticate the user
        // Which is required to call lambda functions for creating Raven account and accepting the invitation in `/finalize-invite`
        // So redirect to login page
        // And continue the process from there
        if(e.message === "authenticateRegisteredUser: userInformation not found"){
            HistoryUtil.push('/');
            return;
        }

        if (e.__type === "CodeMismatchException") {
            this.setState({
                errorMessage: strings.formatString(strings.verify_account_error_code_mismatch)
            });
            return;
        }

        document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));

        this.setState({
            errorMessage: strings.formatString(strings.verify_account_error)
        });
    }

    registerUserSuccess = (e) => {
        const params = new URLSearchParams(window.location.search);
        const userType = params.get('userType');
        const driverName = params.get('driverName');
        const email = this.getUserNameFromUrl();
        const stage = BuildSettings.environment();

        if (this.props.pendingInvite) {
            // document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            HistoryUtil.push('/finalize-invite');

        } else {
            document.dispatchEvent(new CustomEvent(Events.HIDE_LOADING_PAGE));
            document.dispatchEvent(Events.showLoading({ style: 'success' }));
            setTimeout(() => {
                CognitoUtil.logout();
                HistoryUtil.push('/');
            }, 2000);
        }
    }

    getUserNameFromUrl = () => {
        let username = window.location.hash.replace(/^#/, '');
        if (username.includes('?')) {
            username = username.split('?')[0];
        }
        return username;
    }

    validateForm() {

        var verificationCodeV = this.verificationCode.value.length === 6;
        if (verificationCodeV) {
            this.setState({
                validateVerificationCodeMessage: null
            });
            return true;
        } else {
            var verificationCodeMessage = verificationCodeV === true ? null : strings.formatString(strings.signup_error_required);
            this.setState({
                validateVerificationCodeMessage: verificationCodeMessage,
            });
            return false;
        }
    }

    render() {

        var verificationCodeMessage = this.state.validateVerificationCodeMessage ?
            <p className="error-message">{this.state.validateVerificationCodeMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        var errorMessage = this.state.errorMessage ?
            <p className="error-message">{this.state.errorMessage}</p> :
            <p className="error-message">&nbsp;</p>;
        
        let resendButtonContent;
        if (this.state.resendStatus === 'sending') {
            resendButtonContent = strings.formatString(strings.verify_account_resending_code);
        } else if (this.state.resendStatus === 'sent') {
            resendButtonContent = strings.formatString(strings.verify_account_code_sent);
        } else {
            resendButtonContent = strings.formatString(strings.verify_account_resend_code);
        }

        return (
            <div id="createAccountPage" className="container">
                <div className="container-fluid">
                    <div className="row">

                        <div className="col-12 col-md-6 mx-auto main-group">
                            <form className="row verify-account-form" onSubmit={this.onSubmit}>

                                <div className="col-12">
                                    <h1>{strings.formatString(strings.verify_account_title)}</h1>
                                    <p>{strings.formatString(strings.verify_account_message)}</p>
                                </div>

                                <div className="col-12">
                                    <label htmlFor="verificationCode">{strings.formatString(strings.verify_account_code)}</label>
                                    <input id="verificationCode" ref={(verificationCode) => { this.verificationCode = verificationCode }} type="number" placeholder="eg. 123456" />
                                    {verificationCodeMessage}
                                </div>
                                <div className="col-12 action-btns">
                                    <button className="btn-link" onClick={this.onResendCode} disabled={this.state.resendStatus === 'sending' || this.state.resendStatus === 'sent'}>
                                        {resendButtonContent}
                                    </button>
                                    <button className="btn"><i className="material-icons">check</i>{strings.formatString(strings.btn_send_verify_account)}</button>
                                </div>
                                <div>
                                    {errorMessage}
                                </div>

                            </form>
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}
